import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  adminGoogleSession, setAdminToken, setAdminUser, ADMIN_USERS, GOOGLE_PENDING_USER_KEY,
} from "@/lib/api";

export default function AdminGoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const pendingUser = localStorage.getItem(GOOGLE_PENDING_USER_KEY);
    localStorage.removeItem(GOOGLE_PENDING_USER_KEY);
    (async () => {
      try {
        const data = await adminGoogleSession(sessionId, pendingUser);
        setAdminToken(data.token);
        setAdminUser(data.user_id);
        const name = ADMIN_USERS.find((u) => u.id === data.user_id)?.name || "";
        toast.success(`Welcome back, ${name} · signed in with ${data.email}`);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed. Please try again.");
      }
      navigate("/admin", { replace: true });
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-white" data-testid="admin-google-callback">
      <Loader2 className="h-6 w-6 animate-spin" style={{ color: "#0B2545" }} />
    </div>
  );
}
